exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-nav-link[data-v-20803c52]{color:#282d3b!important}.carousel-control-next[data-v-20803c52],.carousel-control-prev[data-v-20803c52]{filter:invert(100%)}.additional-item-price-box[data-v-20803c52]{display:block}.additional-item-price-box[data-v-20803c52]:after{content:\"+\"}.additional-item-price-box[data-v-20803c52]:last-child:after{content:\"\"}", ""]);

// exports
